
import { post, PostConfig } from "@/assets/utils/common";
import { api } from "@/assets/utils/config";
import { defineComponent } from "vue";
import mpPopover from "../../../../components/mp-popover/mp-popover.vue";
import slideInfo from "../slide-info/slide-info.vue";
import EvalDetail from "../eval-detail/eval-detail.vue";
import EvalBlockItem from "./components/EvalBlockItem.vue";
import { formatImage } from "@/assets/utils/pipe";

export default defineComponent({
  components: {
    mpPopover,
    slideInfo,
    EvalDetail,
    EvalBlockItem,
  },

  data() {
    return {
      userList: <any>[],
      decorateList: [
        // { position: 'top-right', url: require('/src/assets/images/home_pic3_bg2.png'), width: 33 },
      ],
      fullList: [],
      userIndex: 0,
    };
  },

  mounted() {
    this.getEvaluateLast20();
  },

  methods: {
    getItem(itemIndex: number) {
      let index = this.userIndex + 1;
      if (index > this.fullList.length - 1) index = 0;
      this.userIndex = index;

      this.userList[itemIndex] = this.fullList[index];
    },

    getEvaluateLast20() {
      let config: PostConfig = {
        url: api.getEvaluateLast20,
      };
      post(config).then((res: any) => {
        if (res.status == 0) {
          res.data.map((item: any) => {
            item.uheader = formatImage(item.uheader, 'square');
          });
          this.fullList = res.data;
          this.userList = [{}, ...res.data.slice(0, 18)];
          this.userIndex = 18 - 1;
        }
      });
    },
  },
});
